(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-services-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOpenCollapsibles() {
      document.querySelectorAll('.services-grid__features [data-collapsible][open="true"]').forEach(function (collapsible) {
        var body = collapsible.querySelector('[data-collapsible-body]');
        var content = collapsible.querySelector('[data-collapsible-content]');
        if (body && content) {
          body.style.height = content.offsetHeight + 'px';
          setTimeout(function () { body.style.height = 'auto'; }, 310);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOpenCollapsibles);
    } else {
      initOpenCollapsibles();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
